import { Drawer } from "antd";
import useSupportStore from "../../stores/useSupportStore";
import TicketList from "./TicketList";
import TicketDetail from "./TicketDetail";

const SupportDrawer = () => {
  const { drawerOpen, closeDrawer, selectedTicketId, selectedTicketDetail } = useSupportStore();

  return (
    <Drawer
      title="My Tickets"
      open={drawerOpen}
      onClose={closeDrawer}
      width={420}
      placement="right"
      zIndex={100000}
      destroyOnHidden
    >
      {selectedTicketId && selectedTicketDetail ? <TicketDetail /> : <TicketList />}
    </Drawer>
  );
};

export default SupportDrawer;
